import { observable, runInAction } from 'mobx'

interface Data {
  size: number
  page: number
}

class Pagination {
  data = observable.object<Data>({ size: 10, page: 0 })

  get size() {
    return this.data.size
  }
  set size(size: number) {
    runInAction(() => {
      this.data.size = size
    })
  }
  get page() {
    return this.data.page
  }
  set page(page: number) {
    runInAction(() => {
      this.data.page = page
    })
  }
}

export default Pagination
